import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import { CustomerDetailService } from '../customer-detail';

import { CustomerEditService } from './customer-edit.service';

@Component({
  selector: 'app-customer-edit',
  templateUrl: './customer-edit.component.html',
  styleUrls: ['./customer-edit.component.css']
})
export class CustomerEditComponent implements OnInit {

    @ViewChild('dangerModal') dangerModal: any;

  customerId = '';
  customer: any;
  isRequired = false;

  redirect = true;

    editCustomerForm: FormGroup;
    contactEmailOne: string = "";
    contactEmailTwo: string = "";
    contactNumberOne: string = "";
    contactNumberTwo: string = "";
    contactPersonOne: string = "";
    contactPersonTwo: string = "";
    loginEmail: string = "";
    name: string = "";
    shortName: string = "";


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private customerEditService: CustomerEditService,
    private customerDetailService: CustomerDetailService,
    private formBuilder: FormBuilder,
    ) {
    this.route.params.subscribe(params => { this.customerId = params['id']; });
    translateService.setDefaultLang('en-us');
}

createEditCustomerForm() {
        this.editCustomerForm = this.formBuilder.group({
            contactEmailOne: new FormControl('', [
                Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
                Validators.maxLength(100)
            ]),
            contactEmailTwo: new FormControl('', [
                Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
                Validators.maxLength(100)
            ]),
            contactNumberOne: new FormControl('', [
                Validators.maxLength(100)
            ]),
            contactNumberTwo: new FormControl('', [
                Validators.maxLength(100)
            ]),
            contactPersonOne: new FormControl('', [
                Validators.maxLength(100)
            ]),
            contactPersonTwo: new FormControl('', [
                Validators.maxLength(100)
            ]),
            customerProjectContactEmailOne: new FormControl('', [
              Validators.maxLength(100),
              Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
            ]),
            customerProjectContactEmailTwo: new FormControl('', [
              Validators.maxLength(100),
              Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
            ]),      
            customerProjectContactNumberOne: new FormControl('', [
              Validators.maxLength(100)
            ]),      
            customerProjectContactNumberTwo: new FormControl('', [
              Validators.maxLength(100)
            ]),
            customerProjectContactNameOne: new FormControl('', [
              Validators.maxLength(100)
            ]),
            customerProjectContactNameTwo: new FormControl('', [
              Validators.maxLength(100)
            ]),
            loginEmail: new FormControl('', [
                Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
                Validators.maxLength(100)
            ]),
            name: new FormControl('', [
                Validators.required,
                Validators.maxLength(100)
            ]),
            shortName: new FormControl('', [
                Validators.required,
                Validators.maxLength(100)
            ]),
        });
}

editCustomer(editCustomerForm) {

        this.customerEditService.edit(this.customerId, editCustomerForm.controls).subscribe(
            data  => {
                if (data) {
                    this.dialog.showModal('showSucModalBtn');
                }
            },
            error => {
                this.exception.showError(error, 'showDanModalBtn');
                this.redirect = false;
            }
        );

    }

  ngOnInit() {
      this.createEditCustomerForm();
   
        this.customerDetailService.getDetail(this.customerId).subscribe( (data) => {

            this.customer = data;

            this.editCustomerForm.patchValue({
                contactEmailOne: this.customer.contactEmailOne ,
                contactEmailTwo: this.customer.contactEmailTwo ,
                contactNumberOne: this.customer.contactNumberOne ,
                contactNumberTwo: this.customer.contactNumberTwo ,
                contactPersonOne: this.customer.contactPersonOne ,
                contactPersonTwo: this.customer.contactPersonTwo ,
                customerProjectContactNameOne: this.customer.customerProjectContactNameOne,
                customerProjectContactNumberOne: this.customer.customerProjectContactNumberOne,
                customerProjectContactEmailOne: this.customer.customerProjectContactEmailOne,
                customerProjectContactNameTwo: this.customer.customerProjectContactNameTwo,
                customerProjectContactNumberTwo: this.customer.customerProjectContactNumberTwo,
                customerProjectContactEmailTwo: this.customer.customerProjectContactEmailTwo,
                loginEmail: this.customer.loginEmail ,
                name: this.customer.name ,
                shortName: this.customer.shortName ,

                });
                console.log(data, this.editCustomerForm.value);
                
            if (this.customer.loginEmail != null) {
                this.isRequired = true;
            }
            else {
                this.isRequired = false;
            }

        },
        error => {
            $('.card').hide();
            this.exception.showError(error, 'showDanModalBtn');
            this.redirect = true;
        }
    );
    
  

  }

  closeSuccessModel() {
    this.router.navigate(['/home/customers/detail/' + this.customerId]);
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/customers']);
    }
    else {
      this.dangerModal.hide();
    }

  }



}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-edit/customer-edit.component.ts